import {CommentOverview, DataLinkOverview, Icon, IconName} from "@dv5/components"
import {CanvasSettings, Widget} from "@dv5/domain"
import {ReactElement, ReactNode, RefObject} from "react"
import {WidgetEditorHandlers} from "../../hooks/useWidgetEditor"
import {OnDeleteDataLink, OnNavigate} from "../../model/WidgetProps"
import {widgetService} from "../../services/widgetService"
import {WidgetTypeBadge} from "./WidgetTypeBadge"
import './WidgetFrame.less'

interface Props {
    baseClass: string
    canvasId: string
    widget: Widget
    settings: CanvasSettings
    selected: boolean
    editingWidgetId: string | undefined
    resizeCursor: string
    handlers: WidgetEditorHandlers
    containerRef: RefObject<HTMLDivElement | null>
    renderResizeHandles: () => ReactElement
    renderLinkDots: () => ReactElement
    onNavigate: OnNavigate
    onDeleteDataLink: OnDeleteDataLink
    showTypeIconOnHover?: boolean
    children: ReactNode
}

export const WidgetFrame = ({
                                baseClass,
                                canvasId,
                                widget,
                                settings,
                                selected,
                                editingWidgetId,
                                resizeCursor,
                                handlers,
                                containerRef,
                                renderResizeHandles,
                                renderLinkDots,
                                onNavigate,
                                onDeleteDataLink,
                                showTypeIconOnHover,
                                children,
                            }: Props) => {
    return (
        <div
            className={widgetService.getWidgetClasses(widget, baseClass, selected, editingWidgetId, widget.commentsCount > 0)}
            style={{...widgetService.getWidgetStyle(widget), cursor: resizeCursor}}
            {...handlers}
            ref={containerRef}
        >
            {renderResizeHandles()}
            {renderLinkDots()}
            {showTypeIconOnHover && <WidgetTypeBadge type={widget.type}/>}
            {widget.locked && (
                <div className="widget-lock-badge" title="Locked">
                    <Icon name={IconName.Lock} width="14" height="14"/>
                </div>
            )}
            <DataLinkOverview
                dataLinkCount={widget.dataLinksCount}
                sourceItemId={widget.id}
                onNavigate={onNavigate}
                onShowDialog={() => {
                }}
                onDelete={onDeleteDataLink}
            />
            <CommentOverview
                canvasId={canvasId}
                sourceItemId={widget.id}
                commentsCount={widget.commentsCount}
                getCommentsMsg="canvas.get-widget-comments"
                addCommentMsg="canvas.add-comment"
                editCommentMsg="canvas.edit-widget-comment"
                deleteCommentMsg="canvas.remove-widget-comment"
                markdown={settings.markdownComments}
            />
            {children}
        </div>
    )
}
